import { render, staticRenderFns } from "./OrdererInfo.vue?vue&type=template&id=69435eca&scoped=true&"
import script from "./OrdererInfo.vue?vue&type=script&lang=js&"
export * from "./OrdererInfo.vue?vue&type=script&lang=js&"
import style0 from "./OrdererInfo.vue?vue&type=style&index=0&id=69435eca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69435eca",
  null
  
)

export default component.exports